import React, { FunctionComponent } from 'react';
import type { RecruitmentShowMagazinesProps } from './types';

export const Presentation: FunctionComponent<RecruitmentShowMagazinesProps> = ({
  noimage,
  title,
  isStopped,
  dataCategory,
  dataValue,
  mags,
  isPreview,
  companyId,
  recruitmentId
}) => {
  if (!mags || mags.length === 0) return null;

  console.log('Mags data:', mags); // デバッグ用

  return (
    <div className="recruitment__show__content recruitment__show__company" id="company-mags-section">
      <h2 className="mainTitle">
        {title}
      </h2>

      <div className="recruitment__show__applications__slider js-recruitment-magazines">
        {mags.map((mag, index) => {
          console.log(`Mag ${index}:`, { url: mag.url, title: mag.title, image: mag.image }); // デバッグ用
          return (
            <a
              key={index}
              href={mag.url}
              {...(!isPreview && {
                'data-event-name': 'mag on screen',
                'data-event': 'click',
                'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                'data-value': 'from_mag',
                'data-recruitmentid': recruitmentId,
                'data-companyid': companyId
              })}
              target="_blank"
              className="box gtm-mag-view-count"
              rel="noopener noreferrer"
            >
              <img
                src={mag.image || noimage}
                alt={mag.title || ''}
                onError={(e) => {
                  console.log('Image load error for:', mag.image);
                  e.currentTarget.src = noimage;
                }}
              />
              <p className="body">
                {mag.title || ''}
              </p>
            </a>
          );
        })}
      </div>
    </div>
  );
};
